<template>
    <div class="user-list">
        <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
            <el-form-item label="用户id">
                <el-input placeholder="用户id" v-model.number="filter.userId"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input placeholder="手机号" v-model="filter.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="面试状态">
                <el-select v-model="filter.interviewStatus">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="label,key in map.interview.status" :key="key" :label="label" :value="key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="预约面试时间">
                <el-date-picker
                  v-model="interviewTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="实际面试时间">
                <el-date-picker
                  v-model="actualTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="人才级别">
                <el-select v-model="filter.talentLevel">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="label,key in talentLevels" :key="key" :label="label" :value="label"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="fetch">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini">
            <el-table-column prop="user_id" label="userId">
                <template slot-scope="scope">
                    {{scope.row.userId || '空'}}
                </template>
            </el-table-column>
            <el-table-column prop="phoneNumber" label="手机号"></el-table-column>
            <el-table-column prop="nickName" label="昵称"></el-table-column>
            <el-table-column prop="contactInformation" label="面试联系方式"></el-table-column>
            <el-table-column prop="interviewTime" label="预约面试时间"></el-table-column>
            <el-table-column prop="interviewStatus" label="面试状态">
                <template slot-scope="scope">{{map.interview.status[scope.row.interviewStatus]}}</template>
            </el-table-column>
            <el-table-column prop="actualTime" label="实际面试时间"></el-table-column>
            <el-table-column prop="interviewScore" label="面试评分"></el-table-column>
            <el-table-column prop="feedbackScore" label="评价平均分"></el-table-column>
            <el-table-column prop="activityScore" label="活跃度评分"></el-table-column>
            <el-table-column prop="talentLevel" label="人才评级"></el-table-column>
            <el-table-column prop="orderNum" label="成单数"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <a :href="'/level-detail?id='+scope.row.userId " target="_blank">编辑</a>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="i=>pageNum=i" :page-size="limit" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'
let {
    user
} = api
export default {
    name: 'user-list',
    data() {
        return {
            map,
            loading: true,
            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
            filter: {
                nickName: '',
                phoneNumber: '',
                userId: '',
                interviewStatus: '',
                interviewTimeStart: '',
                interviewTimeEnd: '',
                actualTimeStart: '',
                actualTimeEnd: '',
                talentLevel: '',

            },
            interviewTime: '',
            actualTime: '',
            talentLevels: ['A','B','C'],
        }
    },
    watch: {
        pageNum() {
            this.fetch(2)
        },
        interviewTime(value) {
            if (value.length > 1) {   
                this.filter.interviewTimeStart = value[0]
                this.filter.interviewTimeEnd = value[1]
            }
        },
        actualTime(value) {
            if (value.length > 1) { 
                this.filter.actualTimeStart = value[0]
                this.filter.actualTimeEnd = value[1]
            }
        }
    },
    methods: {
        async fetch(num) {
            if (num == 1) this.pageNum = 1
            let {
                nickName,
                userId,
                phoneNumber,
                interviewStatus,
                interviewTimeStart,
                interviewTimeEnd,
                actualTimeStart,
                actualTimeEnd,
                talentLevel,
            } = this.filter
            let res = await user.level({
                pageNum: this.pageNum,
                nickName,
                userId: Number.isInteger(userId) ? userId : '',
                phoneNumber,
                interviewStatus,
                interviewTimeStart,
                interviewTimeEnd,
                actualTimeStart,
                actualTimeEnd,
                talentLevel,
            })
            let {
                code,
                data,
                pageinfo
            } = res.data;
            if (code == 200) {
              this.list = data
              this.total = pageinfo.totalCount
            }
        },
    },
    mounted() {
        this.fetch()
    }
}
</script>
<style>
.user-list {}
</style>


// WEBPACK FOOTER //
// src/views/user/user-level.vue